import { VALID_DEVICES, VALID_SORT_VALUES } from '@/constants/search'
import { z } from 'zod'

export const searchParamsSchema = z.looseObject({
  sort: z.enum(VALID_SORT_VALUES).optional(),
  genre: z.string().optional(),
  device: z.enum(VALID_DEVICES).optional(),
  keyword: z.string().optional(),
  tab: z.enum(['top', 'games', 'experiences', 'creators', 'videos']).optional(),
  type: z.enum(['all', 'world', 'game', 'experience', 'video']).optional(),
})
